import { onMount } from 'solid-js';

export interface InlineRect {
  top: number;
  left: number;
  width: number;
  height: number;
}

interface Props {
  initial: string;
  rect: InlineRect;
  onCommit: (value: string) => void;
  onCancel: () => void;
}

function wrap(ta: HTMLTextAreaElement, marker: string): void {
  const { selectionStart: s, selectionEnd: e, value } = ta;
  const sel = value.slice(s, e);
  ta.value = value.slice(0, s) + marker + sel + marker + value.slice(e);
  ta.setSelectionRange(s + marker.length, s + marker.length + sel.length);
}

export function InlineEdit(props: Props) {
  let ref: HTMLTextAreaElement | undefined;
  let committed = false;

  const autosize = (ta: HTMLTextAreaElement) => {
    ta.style.height = 'auto';
    ta.style.height = `${ta.scrollHeight}px`;
  };

  onMount(() => {
    if (!ref) return;
    ref.focus();
    ref.setSelectionRange(props.initial.length, props.initial.length);
    autosize(ref);
  });

  const commit = (value: string) => {
    if (committed) return;
    committed = true;
    props.onCommit(value);
  };

  return (
    <textarea
      ref={ref}
      class="inline-edit"
      spellcheck={false}
      style={{
        position: 'absolute',
        top: `${props.rect.top}px`,
        left: `${props.rect.left}px`,
        width: `${props.rect.width}px`,
        'min-height': `${props.rect.height}px`,
      }}
      onInput={(e) => autosize(e.currentTarget)}
      onBlur={(e) => commit(e.currentTarget.value)}
      onKeyDown={(e) => {
        const ta = e.currentTarget as HTMLTextAreaElement;
        if (e.key === 'Escape') {
          e.preventDefault();
          committed = true;
          props.onCancel();
        } else if (e.key === 'Enter' && (e.metaKey || e.ctrlKey)) {
          e.preventDefault();
          commit(ta.value);
        } else if ((e.metaKey || e.ctrlKey) && !e.altKey) {
          if (e.key === 'b' || e.key === 'B') { e.preventDefault(); wrap(ta, '**'); autosize(ta); }
          else if (e.key === 'i' || e.key === 'I') { e.preventDefault(); wrap(ta, '*'); autosize(ta); }
          else if ((e.key === 'x' || e.key === 'X') && e.shiftKey) { e.preventDefault(); wrap(ta, '~~'); autosize(ta); }
        }
      }}
    >{props.initial}</textarea>
  );
}
